module.exports = __webpack_public_path__ + "img/pie.c0264020.png";